import styled from 'styled-components';

// *** Components ***
export const Timestamp = styled.time``;
